import { memo } from 'react';

import CheckListIconSVG from '@/assets/check-list-icon.svg?react';
import { Icon, IconProps } from '@/components/core';

const ICheckListIcon = (props: Omit<IconProps, 'SVGComponent'>) => <Icon SVGComponent={CheckListIconSVG} {...props} />;

export const CheckListIcon = memo(ICheckListIcon) as typeof ICheckListIcon;
